module.exports = __webpack_public_path__ + "static/scale-model-of-the-creature-conservancy-in-ann-arbor-michigan-08900cf19e6f8f0666325260b8e50d26.png";